import styled from 'styled-components'

export const MTFieldsStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .MuiChip-root {
    max-width: 100%;
  }

  .MuiChip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: ${props => props.useCapitalize};
  }
`
